/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctString, FctValue } from '../../../Fct/generics';
var operatorOptions = [
    { name: 'equal', value: 'equal' },
    { name: 'greater than', value: 'greater than' },
    { name: 'greater equal than', value: 'greater equal than' },
    { name: 'or', value: 'or' },
    { name: 'or not', value: 'or not' },
    { name: 'and', value: 'and' },
    { name: 'and not', value: 'and not' },
    { name: 'not equal', value: 'not equal' },
];
export var Validate = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'VALIDATION',
    method: 'validate',
    name: 'validate',
    getParams: function () { return ({
        input: {
            nodeId: new FctString({ readonly: true }),
            methodParams: {
                id: new FctString({ readonly: true }),
                value1: new FctValue({ required: false }),
                operator: new FctString({ options: operatorOptions, mode: 'INPUT' }),
                value2: new FctValue({ required: false }),
            },
        },
        output: {
            result: new FctValue({ innerIndex: 0, }),
        },
    }); },
    onChange: function (_a) {
        var input = _a.input, output = _a.output;
        var _b = input.methodParams, id = _b.id, value1 = _b.value1, operator = _b.operator, value2 = _b.value2;
        output.result.set({
            value: {
                id: id.value,
                type: 'validation',
                value1: value1.value || '',
                operator: (operator.value || ''),
                value2: value2.value || '',
            },
        });
    },
});
